import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import 'leaflet/dist/leaflet.css';

function mount() {
  let rootElement = document.getElementById('root');
  if (!rootElement) {
    rootElement = document.createElement('div');
    rootElement.id = 'root';
    if (document.body) {
      document.body.appendChild(rootElement);
    } else {
      document.documentElement.appendChild(rootElement);
    }
  }

  try {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (err) {
    console.error('JobMatch NG Mount Exception:', err);
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background-color: #f8fafc; font-family: sans-serif; padding: 20px;">
          <div style="max-width: 480px; width: 100%; background: #ffffff; padding: 32px; border-radius: 16px; box-shadow: 0 10px 25px rgba(0,0,0,0.08); text-align: center; border: 1px solid #e2e8f0;">
            <div style="width: 50px; height: 50px; background: #ecfdf5; color: #059669; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; font-size: 24px;">⚡</div>
            <h1 style="font-size: 22px; font-weight: 700; color: #0f172a; margin: 0 0 8px;">JobMatch NG</h1>
            <p style="font-size: 14px; color: #64748b; margin: 0 0 20px;">Connecting you to Nigeria's verified artisans.</p>
            <button onclick="localStorage.clear(); window.location.reload();" style="width: 100%; padding: 12px; background: #059669; color: #ffffff; border: none; border-radius: 10px; font-weight: 600; cursor: pointer;">Start Fresh Session</button>
          </div>
        </div>
      `;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
